import {
  type ComponentType,
  Fragment,
  useState,
  type FC,
  type ReactNode,
  MouseEvent,
} from "react"
import {
  Menu as MUIMenu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  IconButtonProps,
  Stack,
} from "@mui/material"
import {WarningIcon2} from "../../../assets/icons"
import {Tooltip} from "../atoms"
import {useTranslation} from "react-i18next"

type Props = {
  Trigger: ComponentType<IconButtonProps>
  items: Array<{
    icon: ReactNode
    text: string
    onClick: () => void
    warningIcon?: boolean
  }>
}
const Menu: FC<Props> = (props) => {
  const {Trigger, items} = props
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null)
  const open = Boolean(anchorEl)
  const {t} = useTranslation()
  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <Fragment>
      <Trigger onClick={handleOpen} />
      <MUIMenu
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        sx={{
          "& .MuiMenu-paper": {
            minWidth: "200px",
            backgroundColor: "#FFFFFF",
            borderRadius: "0.25rem",
            borderStyle: "solid",
            borderWidth: "1px",
            borderColor: "#DFDFDF",
            top: "35px !important",
            right: "85px",
            left: "unset !important",
          },
          "& .MuiMenu-list": {
            padding: "0",
          },
          "& .MuiMenuItem-root": {
            padding: "0.40625rem 1rem",
            "&:hover": {
              backgroundColor: "#F2F2F2",
            },
          },
        }}
      >
        {items.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              handleClose()
              item.onClick()
            }}
          >
            <ListItemIcon
              sx={{
                div: {
                  width: "1.25rem",
                  height: "1.25rem",
                },
                svg: {
                  width: "1.25rem",
                  height: "1.25rem",
                  fill: "#242D35",
                },
              }}
            >
              {item.icon}
            </ListItemIcon>
            <ListItemText
              color="#242D35"
              sx={{
                fontSize: "0.875rem",
                lineHeight: "1.25rem",
                fontWeight: 400,
                "& .MuiTypography-root": {
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "8px",
                },
              }}
            >
              {item.text}
              {item.warningIcon && (
                <Tooltip
                  title={t("Please update your preferences")}
                  arrow
                  placement="bottom"
                >
                  <Stack>
                    <WarningIcon2
                      fill="#f98500"
                      height={"14px"}
                      width={"14px"}
                    />
                  </Stack>
                </Tooltip>
              )}
            </ListItemText>
          </MenuItem>
        ))}
      </MUIMenu>
    </Fragment>
  )
}

export default Menu
